import { getRoot, Instance, IStateTreeNode } from 'mobx-state-tree';
import { IRootStore } from '@stores/RootStore';
import { IAlertStore } from './types';

export const withAlertStore = (self: IStateTreeNode) => {
  return {
    views: {
      get alertStore(): IAlertStore {
        return getRoot<IRootStore>(self).alertStore;
      },
    },
  };
};
